var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDetection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-detection_svg__clip0_6773_8015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.682 5.35v-2l2-2 .667 1.332 1.333.667-2 2h-2zm0 0L8.016 8.015m6.666 0a6.667 6.667 0 11-6.666-6.667m3.333 6.667a3.333 3.333 0 11-3.333-3.334",
    stroke: "#fff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-detection_svg__clip0_6773_8015"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.016 .016)",
    d: "M0 0h16v16H0z"
  })))));
}
export default SvgIconDetection;